///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor = abcsetup.new_vendor || {};
abcsetup.new_vendor.edit = abcsetup.new_vendor.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor.edit = {
    /**
     *
     */
    init: function () {
        abcsetup.setTitle('SAP Supplier');

        if ($("input[name='workflow_id']").val()){
            $(document).on("change","input[name='supplier_contact_email_address']", function(){
                $(".btn-resend-invite").remove();
                $(this).after('<button class="btn btn-primary mt-2 btn-resend-invite" type="submit" name="form_action" value="resend_notification" title="" data-original-title="Click to resend invite email">Submit & Resend Invite</button>');
            });
        }
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // Bind any fields events
        abcsetup.new_vendor.common.bindFields();
    },

    /**
     * bootstrap-autocomplete - this is the callback when an item is selected
     */
    autoCompleteSelected: function() {
        abcsetup.new_vendor.common.autoCompleteSelected();
    },

    /**
     * bootstrap-autocomplete - this is the callback when a free form value is entered
     */
    autoCompleteFreevalue: function() {
        abcsetup.new_vendor.common.autoCompleteFreevalue();
    },
}
